import React, { useEffect } from 'react';
import { Form, Modal, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../rootReducer';
import { alarmDescriptionInit } from '../../slices/alarmDescriptionSlice';
import { CONSTANTS_REQ } from '../../utils/Constants';
import TextArea from 'antd/lib/input/TextArea';
import { refreshDeviceAlarmList } from '../../slices/alarmDescriptionSlice';
import { refreshAlarmList } from '../../slices/dashboardSlice';
import { geti18nText, NyRequestResolver, RESPONSE } from '@nybble/nyreact';

const AlarmEditDescription: React.FC = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const { deviceId, data, visible, deviceType } = useSelector((state: RootState) => state.alarmDescriptionSlice);
    const hideModal = () => {
        dispatch(alarmDescriptionInit());
    };

    useEffect(() => {
        if (data != undefined) form.setFieldsValue(data);
    }, [data]);

    function save(values: any) {
        NyRequestResolver.requestPut(CONSTANTS_REQ.DEVICE.DEVICE_ALARM_DESCRIPTION + '/' + deviceId, undefined, {
            id: deviceId,
            description: values.description,
            deviceType: deviceType,
        }).then((result: any) => {
            if (result && result.status === RESPONSE.CREATED) {
                notification.success({
                    message: geti18nText('app.default.save.ok'),
                    description: geti18nText('app.default.save.ok.desc'),
                    duration: 3,
                });

                dispatch(refreshAlarmList());
                dispatch(refreshDeviceAlarmList());

                hideModal();
            } else {
                notification.error({ message: geti18nText('app.default.save.nok'), description: '' });
            }
        });
    }

    return (
        <React.Fragment>
            <Modal
                zIndex={1010}
                visible={visible}
                title={geti18nText('dashboard.widget.alarm.edit.description.title')}
                onCancel={() => hideModal()}
                okText={geti18nText('app.default.button.save')}
                width={600}
                onOk={() => {
                    form.validateFields().then((values) => {
                        save(values);
                    });
                }}
            >
                <Form form={form} layout="horizontal" labelCol={{ span: 4 }}>
                    <Form.Item
                        name="description"
                        label={geti18nText('dashboard.widget.alarm.edit.description.description')}
                        initialValue={data && data.description ? data.description : ''}
                    >
                        <TextArea autoSize={{ minRows: 2, maxRows: 6 }} />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    );
};

export default AlarmEditDescription;
